// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__N2G94","vLegacy":"SelectSecondary_vLegacy__CJ6c7","error":"SelectSecondary_error__1M0Pm","disabled":"SelectSecondary_disabled__1NKuC"};